'use strict'
import { serverApi } from '@/server';

export default {
    /**
     * 任务广场添加
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/tasks
     * @param {Object} formData
     * @returns {Promise}
     */
    addTasks(formData) {
        const url = '/tasks'
        return serverApi.post(formData, url)
    },
    /**
     * 任务广场修改保存
     *
     * @author nick
     *
     * @method PUT
     *
     * @url /spa/tasks/{id}
     * @param {Object} formData
     * @returns {Promise}
     */
    editTasks(formData,id) {
        const url = `/tasks/${id}`
        return serverApi.put(formData, url)
    },
    /**
     * 任务描述模板-所有无分页
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-templates-all
     * @param {Object} formData
     * @returns {Promise}
     */
    taskTemplatesAll(formData) {
        const url = '/task-templates-all'
        return serverApi.get(formData, url)
    },
    /**
     * 任务广场列表+搜索
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/tasks
     * @param {Object} formData
     * @returns {Promise}
     */
    getTasks(formData) {
        const url = '/tasks'
        return serverApi.get(formData, url)
    },
    /**
     * 任务广场详情
     *
     * @author nick
     *
     * @method GET
     *
     * @param {Number} id 任务id
     * @url /spa/tasks/{id}
     *
     * @returns {Promise}
     */
    getTasksInfo(id) {
        const url = `/tasks/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 任务复制数据
     *
     * @author nick
     *
     * @method GET
     *
     * @param {Number} id 任务id
     * @url /spa/tasks/{id}
     *
     * @returns {Promise}
     */
    getTaskCopyInfo(id) {
        const url = `/task-copy-show/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 编辑任务广场详情
     *
     * @author nick
     *
     * @method GET
     *
     * @param {Number} id 任务id
     * @url /spa/tasks/{id}/edit
     *
     * @returns {Promise}
     */
    getEditTasksInfo(id) {
        const url = `/tasks/${id}/edit`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理列表+搜索
     *
     * @author nick
     *
     * @method GET
     *
     * @param {Number} id 任务id
     * @url /spa/task-applicants/{taskNo}
     *
     * @returns {Promise}
     */
    getTasksApplicants(formData,id) {
        const url = `/task-applicants/${id}`
        return serverApi.get(formData, url)
    },
    /**
     * 任务详情-报名管理-批量录用/淘汰
     *
     * @author nick
     *
     * @method PUT
     *
     * @param {Object} formData formData
     * @url /spa/task-applicants/apply
     *
     * @returns {Promise}
     */
    tasksApplicantsApply(formData) {
        const url = `/task-applicants/apply`
        return serverApi.put(formData, url)
    },
    /**
     * 任务详情-报名管理-批量删除
     *
     * @author nick
     *
     * @method PUT
     *
     * @param {Object} formData formData
     * @url /spa/task-applicants/apply
     *
     * @returns {Promise}
     */
    tasksApplicantsDelete(formData) {
        const url = `/task-applicants/delete`
        return serverApi.post(formData, url)
    },
    /**
     * 任务详情-报名管理-短信提醒
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData formData
     * @url /spa/task-applicants/apply
     *
     * @returns {Promise}
     */
    tasksApplicantsRemind(formData) {
        const url = `/task-applicants/remind`
        return serverApi.post(formData, url)
    },



    /**
     * 任务类型列表
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-categories
     *
     * @returns {Promise}
     */
    getTaskCategoriesList() {
        const url = `/task-categories`
        return serverApi.get({}, url)
    },
    /**
     * 任务广场发布显示隐藏
     *
     * @author nick
     *
     * @method PUT
     *
     * @url /spa/tasks-is-public/{id}
     *
     * @returns {Promise}
     */
    tasksIsPublic(formData,id) {
        const url = `/tasks-is-public/${id}`
        return serverApi.put(formData, url)
    },
    /**
     * 任务处理
     *
     * @author nick
     *
     * @method PUT
     *
     * @url /spa/tasks-state-update/{id}
     *
     * @returns {Promise}
     */
    tasksStateUpdate(formData,id) {
        const url = `/tasks-state-update/${id}`
        return serverApi.put(formData, url)
    },
    /**
     * 任务详情-报名管理-数量统计
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-applicant-statistics/{taskNo}
     *
     * @returns {Promise}
     */
    tasksApplicantStatistics(id) {
        const url = `/task-applicant-statistics/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理-查看履历
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-introductions/{id}
     *
     * @returns {Promise}
     */
    tasksIntroductions(id) {
        const url = `/task-introductions/${id}`
        return serverApi.get({}, url)
    },

    /**
     * 任务详情-任务验收列表+搜索
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-acceptances/{taskNo}
     *
     * @returns {Promise}
     */
    tasksAcceptances(formData,taskNo) {
        const url = `/task-acceptances/${taskNo}`
        return serverApi.get(formData, url)
    },
    /**
     * 任务详情-任务验收-数量统计
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-acceptance-statistics/{taskNo}
     *
     * @returns {Promise}
     */
    tasksAcceptancesStatistics(taskNo) {
        const url = `/task-acceptance-statistics/${taskNo}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-任务验收-任务反馈
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-feedback/{id}
     *
     * @returns {Promise}
     */
    taskFeedback(id) {
        const url = `/task-feedback/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-任务验收-批量验收/驳回
     *
     * @author nick
     *
     * @method PUT
     *
     * @url /spa/task-acceptances/feedback
     *
     * @returns {Promise}
     */
    taskAcceptancesFeedback(formData) {
        const url = `/task-acceptances/feedback`
        return serverApi.put(formData, url)
    },


    /**
     * 任务详情-结算名单-数量统计
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-settlement-statistics/{taskNo}
     *
     * @returns {Promise}
     */
    taskSettlementStatistics(taskNo) {
        const url = `/task-settlement-statistics/${taskNo}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-结算名单列表+搜索
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-settlements/{taskNo}
     *
     * @returns {Promise}
     */
    taskSettlementList(formData,taskNo) {
        const url = `/task-settlements/${taskNo}`
        return serverApi.get(formData, url)
    },
    /**
     * 任务详情-结算名单-结算名单导出
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData
     * @url /spa/task-settlements/export
     *
     * @returns {Promise}
     */
    taskSettlementsExport(formData) {
        const url = `/task-settlements/export`
        return serverApi.downLoadByPost(formData, url, '结算名单.xlsx');

    },



    /**
     * 任务详情-报名管理-导入并录用
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/task-applicants/batch-import
     *
     * @returns {Promise}
     */
    tasksApplicantsBatchImport(formData) {
        const url = `/task-applicants/batch-import`
        return serverApi.post(formData, url)
    },
    /**
     * 任务详情-报名管理-导入录用-返回当前是否有任务处理
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/has-task-applicants/{taskNo}
     *
     * @returns {Promise}
     */
    hasTaskApplicants(taskNo) {
        const url = `/has-task-applicants/${taskNo}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理-导入录用-核验进度
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-applicant-caches/bar/{taskNo}
     *
     * @returns {Promise}
     */
    taskApplicantCachesBar(taskNo) {
        const url = `/task-applicant-caches/bar/${taskNo}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理-导入录用-取消上传
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/task-applicants/batch-import/recall
     *
     * @returns {Promise}
     */
    taskApplicantsBatchImportRecall(formData) {
        const url = `/task-applicants/batch-import/recall`
        return serverApi.post(formData, url)
    },
    /**
     * 任务详情-报名管理-导入并录用-核验结果统计
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-applicant-caches/{task_no}
     *
     * @returns {Promise}
     */
    taskApplicantsCaches(task_no) {
        const url = `/task-applicant-caches/${task_no}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理-导入并录用-核验结果列表
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-applicant-caches
     *
     * @returns {Promise}
     */
    taskApplicantsCachesList(formData) {
        const url = `/task-applicant-caches`
        return serverApi.get(formData, url)
    },
    /**
     * 任务详情-报名管理-导入并录用-未通过数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @param {Object} formData
     * @url /spa/unpass-task-applicants/export
     *
     * @returns {Promise}
     */
    unpassTaskApplicantsExport(formData) {
        const url = `/unpass-task-applicants/export`
        return serverApi.downLoadByPost(formData, url, '未通过数据.xlsx');

    },
    /**
     * 任务详情-报名管理-导入并录用提交
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/task-applicants/batch-import/submit
     *
     * @returns {Promise}
     */
    taskApplicantsBatchImportSubmit(formData) {
        const url = `/task-applicants/batch-import/submit`
        return serverApi.post(formData, url)
    },
    /**
     * 任务详情-报名管理-导入录用-二次核验进度
     *
     * @author nick
     *
     * @method GET
     *
     * @url /spa/task-applicant-caches/double-check-bar/{taskno}
     *
     * @returns {Promise}
     */
    taskApplicantCachesDoubleCheckBar(taskno) {
        const url = `/task-applicant-caches/double-check-bar/${taskno}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-报名管理-导入并录用-失败数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/fail-task-applicants/export
     *
     * @returns {Promise}
     */
    failTaskApplicantsExport(formData) {
        const url = `/fail-task-applicants/export`
        return serverApi.downLoadByPost(formData, url, '失败数据下载.xlsx')
    },
    /**
     * 任务详情-身份证号脱敏查看
     *
     * @author nick
     *
     * @method GET
     *
     * @url /task-show-idcard/{id}
     *
     * @returns {Promise}
     */
    taskShowIdCard(id) {
        const url = `/task-show-idcard/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-手机号脱敏查看
     *
     * @author nick
     *
     * @method GET
     *
     * @url /task-show-phone/{id}
     *
     * @returns {Promise}
     */
    taskShowPhone(id) {
        const url = `/task-show-phone/${id}`
        return serverApi.get({}, url)
    },
    /**
     * 任务详情-收款账号脱敏查看
     *
     * @author nick
     *
     * @method GET
     *
     * @url /task-show-cardno/{id}
     *
     * @returns {Promise}
     */
    taskShowCardNo(id) {
        const url = `/task-show-cardno/${id}`
        return serverApi.get({}, url)
    },

    /**
     * 协议模板下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/download-protocol
     *
     * @returns {Promise}
     */
    taskDownloadProtocol(formData,name) {
        const url = `/download-protocol`
        return serverApi.downLoadByPost(formData, url,name)
    },
    /**
     * 协议模板其它文件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/preview-protocol
     *
     * @returns {Promise}
     */
     previewPDF(formData){
          const url=`/preview-protocol`;
          return serverApi.post(formData,url)
      },
      /**
       * 协议模板图片预览
       *
       * @author nick
       *
       * @method POST
       *
       * @url /spa/preview-protocol
       *
       * @returns {Promise}
       */
      previewIMG(formData,fileName){
        const url=`/preview-protocol`;
        return serverApi.preview(formData,url,{ responseType: 'blob' });
      },
    /**
   * 导入录用-通过列表删除数据下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /pass-task-applicants-delete/export
     *
     * @returns {Promise}
     */
    passTaskApplicantsDeleteExport(formData,name) {
        const url = `pass-task-applicants-delete/export`
        return serverApi.downLoadByPost(formData, url,name)
    },
    /**
     * 任务详情-任务验收-获取任务反馈信息
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback/{id}
     *
     * @returns {Promise}
     */
    getTaskFeedbackInfo(id){
        const url=`/task-feedback/${id}`;
        return serverApi.get({},url)
    },
    /**
     * 任务反馈附件下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback-file-download
     *
     * @returns {Promise}
     */
    taskFeedbackFileDownload(formData,name) {
        const url = `/task-feedback-file-download`
        return serverApi.downLoadByPost(formData, url,name)
    },
    /**
     * 任务反馈所有附件压缩下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback-files-download
     *
     * @returns {Promise}
     */
    taskFeedbackAllFilesDownload(formData,name) {
        const url = `/task-feedback-files-download`
        return serverApi.downLoadByPost(formData, url,name,true)
    },
    /**
     * 任务反馈图片附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback-file-preview
     *
     * @returns {Promise}
     */
    taskFeedbackImgPreview(formData){
        const url=`/task-feedback-file-preview`;
        return serverApi.preview(formData,url,{ responseType: 'blob' });
    },
    /**
     * 任务反馈文件附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback-file-preview
     *
     * @returns {Promise}
     */
    taskFeedbackFilePreview(formData){
        const url=`/task-feedback-file-preview`;
        return serverApi.preview(formData,url);
    },
    /**
     * 任务反馈附件批量下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-feedback-file-batch-download
     *
     * @returns {Promise}
     */
    taskFeedbackFileBatchDownload(formData){
        const url=`/task-feedback-file-batch-download`;
        return serverApi.post(formData,url)
    },
    /**
     * 任务详情-报名管理-导入并录用重新核验
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-applicants/batch-import/recheck/{taskId}
     *
     * @returns {Promise}
     */
    taskApplicantsBatchImportRecheck(taskId){
        const url=`/task-applicants/batch-import/recheck/${taskId}`;
        return serverApi.post({},url)
    },
    /**
     *  任务协议预览
     *
     * @author nick
     *
     * @method POST
     * 
     * @url: /spa/preview-protocol
     */
    previewMissionProto(formData) {
        let url = `/preview-protocol`;
        return serverApi.post(formData, url);

    },


    // ---------------------- 2021.4.12 任务改版 ----------------------
    // ---------------------- 2021.4.12 任务改版 ----------------------

    /**
     * 任务模板-所有无分页
     *
     * @author nick
     *
     * @method POST
     *
     * @url /spa/task-templates-all
     *
     * @returns {Promise}
     */
    taskTemplatesAll(formData){
        const url=`/task-templates-all`;
        return serverApi.get(formData,url)
    },
    /**
     * 任务详情-报名管理-单人导入
     *
     * @author nick
     *
     * @method POST
     *
     * @url /task-applicants/single-import
     *
     * @returns {Promise}
     */
    taskApplicantsSingleImport(formData){
        const url=`/task-applicants/single-import`;
        return serverApi.post(formData,url)
    },
    /**
     * 任务详情-获取当前任务下的核验批次
     *
     * @author nick
     *
     * @method GET
     *
     * @url /get-task-applicant-batch/{taskNo}
     *
     * @returns {Promise}
     */
    getTaskApplicantsBatch(taskNo){
        const url =`/get-task-applicant-batch/${taskNo}`;
        return serverApi.get({},url)
    },
    /**
     * 验收材料上传
     *
     * @author nick
     *
     * @method GET
     *
     * @url /upload-checked_file
     *
     * @returns {Promise}
     */
    uploadCheckedFile(formData){
        const url =`/upload-checked_file`;
        return serverApi.post(formData,url)
    },
    /**
     * 验收材料上传
     *
     * @author nick
     *
     * @method GET
     *
     * @url /upload-checked_file
     *
     * @returns {Promise}
     */
    uploadCheckedFile(formData){
        const url =`/upload-checked_file`;
        return serverApi.post(formData,url)
    },
    /**
     * 任务验收下载
     *
     * @author nick
     *
     * @method POST
     *
     * @url /download-checked_file
     *
     * @returns {Promise}
     */
    downloadCheckedFile(formData, name) {
        const url = `/download-checked_file`
        return serverApi.downLoadByPost(formData, url, name)
    },
    /**
     * 任务反馈图片附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /preview-checked_file
     *
     * @returns {Promise}
     */
    previewCheckedFileImg(formData) {
        const url = `/preview-checked_file`;
        return serverApi.preview(formData, url, { responseType: 'blob' });
    },
    /**
     * 任务反馈文件附件预览
     *
     * @author nick
     *
     * @method POST
     *
     * @url /preview-checked_file
     *
     * @returns {Promise}
     */
    previewCheckedFile(formData) {
        const url = `/preview-checked_file`;
        return serverApi.post(formData, url);
    },
    /**
     * 验收操作返回的个数
     *
     * @author nick
     *
     * @method GET
     *
     * @url /get-task-check-info/{taskNo}
     *
     * @returns {Promise}
     */
    getTaskCheckInfo(taskNo) {
        const url = `/get-task-check-info/${taskNo}`;
        return serverApi.get({}, url)
    },
    /**
     * 一键验收
     *
     * @author nick
     *
     * @method GET
     *
     * @url /task-one-key-check
     *
     * @returns {Promise}
     */
    taskOneKeyCheck(formData) {
        const url = `/task-one-key-check`;
        return serverApi.post(formData, url)
    },
}
